import { ReactElement } from "react";
import { newsFeedGroups } from "../newsFeedGroups";

interface NewsFeedsAccordionProps {
  openIndex: number | null;
  onToggle: (index: number) => void;
  onChoose: (lookup: string) => void;
}

export default function NewsFeedsAccordion({ openIndex, onToggle, onChoose }: NewsFeedsAccordionProps): ReactElement {
  return (
    <aside className="news-feeds-accordion" aria-label="News feeds">
      {newsFeedGroups.map((group, index) => {
        const isOpen = openIndex === index;
        return (
          <div className="news-feeds-pane" key={group.title}>
            <button
              type="button"
              className={`news-feeds-pane-button${isOpen ? " is-open" : ""}`}
              aria-expanded={isOpen}
              onClick={() => onToggle(index)}
            >
              <span>{group.title}</span>
              <span className="news-feeds-chevron" aria-hidden="true" />
            </button>
            {isOpen ? (
              <div className="news-feeds-pane-body">
                {group.links.map((link, linkIndex) => (
                  <span key={link.lookup}>
                    {linkIndex > 0 ? ", " : null}
                    <button type="button" onClick={() => onChoose(link.lookup)}>
                      {link.label}
                    </button>
                  </span>
                ))}
              </div>
            ) : null}
          </div>
        );
      })}
    </aside>
  );
}
